export const MESSAGES = [
  {
    id: 1,
    title: "Team Performance Report - October 2025",
    sender: "Hyvid Operations Team",
    priority: "HIGH PRIORITY",
    date: "2025-11-01",
    time: "09:00 AM",
    content: `Dear Client,

We are pleased to share your team's performance report for October 2025. 

Key:
• Overall team productivity: 88% (↑ 5% from last month)
• Average attendance rate: 96%
• Training completion rate: 82%
• Client satisfaction score: 4.7/5.0

Action Items:
1. Review individual performance assessments
2. Schedule Q4 planning meeting
3. Approve pending leave requests (3 pending)

Please contact your dedicated account manager if you have any questions.

Best regards,
Hyvid Operations Team`,
    attachments: [{ name: "Performance_Report_Oct2025.pdf" }],
    isRead: false
  },
  {
    id: 2,
    title: "Remote Work Guidelines Update",
    sender: "Hyvid HR Department",
    priority: "MEDIUM PRIORITY",
    date: "2025-10-15",
    time: "02:00 PM",
    content: `Dear Valued Client,

Important updates to our Remote Work Guidelines, effective November 1, 2025.

Updates Include:
• Extended flexible hours (7 AM - 10 PM local time)
• New hybrid work schedule options
• Enhanced security protocols
• Updated time tracking requirements

Please contact hr@hyvid.com for questions.

Best regards,
Hyvid HR Department`,
    attachments: [{ name: "Remote_Work_Policy_2025.pdf" }],
    isRead: false
  },
  {
    id: 3,
    title: "Quarterly Business Review Q4 2025",
    sender: "Your Hyvid Account Manager",
    priority: "HIGH PRIORITY",
    date: "2025-10-10",
    time: "11:00 AM",
    content: `Hello,

Your Quarterly Business Review (QBR) for Q4 2025 has been scheduled:

Meeting Details:
• Date: October 25, 2025
• Time: 10:00 AM - 11:30 AM
• Format: Virtual (Microsoft Teams)

Agenda:
1. Q3 performance review
2. Q4 objectives and KPIs
3. Team scaling opportunities
4. Technology updates
5. Q&A session

Please review the attached pre-meeting questionnaire by October 22nd.

Best regards,
Your Hyvid Account Manager`,
    attachments: [{ name: "QBR_Questionnaire.pdf" }],
    isRead: false
  },
  {
    id: 4,
    title: "Monthly Invoice - October 2025",
    sender: "Hyvid Payroll Services",
    priority: "MEDIUM PRIORITY",
    date: "2025-11-01",
    time: "10:00 AM",
    content: `Dear Client,

Your monthly invoice for October 2025 is now available.

Invoice Summary:
• Invoice Number: INV-2025-10
• Invoice Date: October 1, 2025
• Due Date: October 15, 2025
• Total Amount: $45,230.00

Please contact billing@hyvid.com if there are discrepancies.

Best regards,
Hyvid Payroll Services`,
    attachments: [],
    isRead: false
  },
  {
    id: 5,
    title: "New Training Courses Available",
    sender: "Hyvid Training Team",
    priority: "LOW PRIORITY",
    date: "2025-10-05",
    time: "03:00 PM",
    content: `Hello!

New training courses are now available for your team:

1. Advanced Data Analytics
2. Leadership & Team Management
3. Cybersecurity Fundamentals
4. Effective Remote Communication
5. Project Management Essentials

Enroll by October 31st to get 20% off.

Best regards,
Hyvid Training Team`,
    attachments: [],
    isRead: false
  },
  {
    id: 6,
    title: "Scheduled System Maintenance",
    sender: "Hyvid Support Team",
    priority: "HIGH PRIORITY",
    date: "2025-10-12",
    time: "08:00 PM",
    content: `Dear Valued Client,

Scheduled system maintenance on October 15, 2025, from 2:00 AM to 6:00 AM UTC.

Affected Services:
• HyvidOne Platform
• Time tracking system
• Reporting dashboard

Please ensure all critical reports are downloaded beforehand.

Best regards,
Hyvid Support Team`,
    attachments: [],
    isRead: false
  }
];
